module.exports = __webpack_public_path__ + "img/widget_accommodation.5f29648.png";